//File: src/pwa.js

/*
 * Critical Design
 * Do not modify this section without explicit permission
 *
 * PWA registration is kept minimal to ensure quick service worker initialization.
 * The registerSW function is imported from vite-plugin-pwa to handle all PWA lifecycle events.
 */

import { registerSW } from 'virtual:pwa-register'

export const registerPWA = () => {
  if ('serviceWorker' in navigator) {
    registerSW()
  }
} 